import IsPublished from "@/shared/models/enums/is-published";
import Grade from "@/shared/models/enums/grade";
import Category from "@/shared/models/entities/repocraft/category";
import TemplateWorkSheet from "@/shared/models/entities/repocraft/template-worksheet";
import { isNud } from '@/shared/utilities/typing';

/**
 * 雛形題材 エンティティ
 */
class TemplateSubject {
    template_subject_id;
    subject_name;
    category;
    grade;
    term;
    lesson_hours_from;
    lesson_hours_to;
    is_published;
    priority;
    description;
    evaluation_item_1;
    evaluation_item_2;
    evaluation_item_3;
    evaluation_item_4;
    evaluation_item_5;
    teaching_plan_domain;
    worksheets;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.template_subject_id = properties.template_subject_id;
        this.subject_name = properties.subject_name;
        this.category = new Category(properties.category);
        this.grade = properties.grade;
        this.term = properties.term;
        this.lesson_hours_from = properties.lesson_hours_from;
        this.lesson_hours_to = properties.lesson_hours_to;
        this.is_published = properties.is_published;
        this.priority = properties.priority;
        this.description = properties.description;
        this.evaluation_item_1 = properties.evaluation_item_1;
        this.evaluation_item_2 = properties.evaluation_item_2;
        this.evaluation_item_3 = properties.evaluation_item_3;
        this.evaluation_item_4 = properties.evaluation_item_4;
        this.evaluation_item_5 = properties.evaluation_item_5;
        this.teaching_plan_domain = properties.teaching_plan_domain;
        this.worksheets = [];
        if ('worksheets' in properties) {
            for (let worksheet of properties.worksheets) {
                this.worksheets.push(new TemplateWorkSheet(worksheet));
            }
        }
    }

    get is_published_display() {
        return IsPublished.get(this.is_published);
    }

    get grade_display() {
        return Grade.get(this.grade);
    }

    get lesson_hours() {
        // from to どちらも存在すれば
        if (this.lesson_hours_from && this.lesson_hours_to) {
            if (this.lesson_hours_from === this.lesson_hours_to) {
                return this.lesson_hours_from;
            }
            return this.lesson_hours_from + ' 〜 ' + this.lesson_hours_to;
        } else if (this.lesson_hours_from || this.lesson_hours_to) {
            return this.lesson_hours_from ? this.lesson_hours_from : this.lesson_hours_to;
        } else {
            return '';
        }
    }
}

export default TemplateSubject;
